import { FunctionComponent } from "react";

import { useMentionCard } from "@/containers/MentionCard/context";
import { cx } from "@/utils";
import Highlight from "@components/Highlight";

import styles from "./TranscriptStatus.module.css";

const TranscriptStatus: FunctionComponent<{ className?: string }> = ({
  className,
}) => {
  const {
    episode: { has_transcript, transcript_status },
  } = useMentionCard();

  let label = null;

  if (has_transcript) {
    if (transcript_status === "queued") {
      label = L.TRANSCRIPTION_STATUS_QUEUED;
    } else if (transcript_status === "indexed") {
      label = null;
    } else if (transcript_status?.includes("failed")) {
      label = L.TRANSCRIPTION_STATUS_FAILED;
    } else {
      label = L.TRANSCRIPTION_STATUS_ONGOING;
    }
    // don't show if has_transcript is undefined
  } else if (has_transcript === false) {
    label = L.TRANSCRIPTION_STATUS_NOT_TRANSCRIBED;
  }

  return label ? (
    <Highlight
      className={cx(styles.root, className, {
        [styles.hasError]: transcript_status?.includes("failed"),
      })}
      label={label}
    />
  ) : null;
};

export default TranscriptStatus;
